import {Map} from "../../../map/BaseMap";
import './MobileZonesView.css'
import backIcon from '../../../imgs/back_arrow.png'
import {Link} from 'react-router-dom';
import {useEffect, useRef, useState} from "react";
import AddressSearch from "../AddressSearch";
import {ISuggestResult} from "../EnterAddressView";
import fingerIcon from '../../../imgs/finger_icon.png'
import {instance} from "../../../networking/axios";
import axios, {AxiosResponse} from "axios";
import {Zones} from "../Zones";
import {IZonesViewState} from "../ZonesView";
import {geocodeAddress} from "../Geocoding";
import {showZone} from "../MapHelpers";
import ZoneLegendCarView from "../ZoneLegendCarView";
import ZonesAbilitiesView from "../abilities/ZonesAbilitiesView";
import {ICity, IConstants} from "../../model/B2CInfo";

interface IMobileZonesViewProps {
    constants: IConstants
    city: ICity
}

export default function MobileZonesView(props: IMobileZonesViewProps) {
    const [addresses, setAddresses] = useState<Array<ISuggestResult>>([])
    const [searchFieldSelected, setSearchFieldSelected] = useState(false)
    const [state, setState] = useState<IZonesViewState>({
        zones: undefined,
        selectedZone: undefined,
    })
    // @ts-ignore
    const [map, setMap] = useState<ymaps.Map>()
    const [coordinate, setCoordinate] = useState<Array<number> | undefined>(undefined)
    const [abilities, setAbilities] = useState<Zones | undefined>(undefined);
    const [addressText, setAddressText] = useState("")
    const [suggest, setSuggest] = useState<ISuggestResult | undefined>(undefined)

    const geocodeTextTokenSource = axios.CancelToken.source();
    const geocodePointTokenSource = axios.CancelToken.source();

    useEffect(() => {
        const params = new URLSearchParams();
        params.append('use_styles', '1');

        instance
            .get('/api/fake/areas/operation/info', {params: params})
            .then((session: AxiosResponse<Zones>) => {
                setState({...state, zones: session.data, selectedZone: session.data.records[0].id})
            })
    }, []);

    useEffect(() => {
        if (coordinate === undefined) {
            return;
        }

        const params = new URLSearchParams();
        params.append('use_styles', '1');
        params.append('coordinate', `${coordinate[0]} ${coordinate[1]}`);

        instance
            .get('/api/fake/areas/operation/info', {params: params})
            .then((session: AxiosResponse<Zones>) => {
                setAbilities(session.data)
            })
    }, [coordinate, state.selectedZone]);

    useEffect(() => {
        if (state.zones == null || map == null) {
            return;
        }

        let selectedZone = state.zones.records.find((zone) => zone.id === state.selectedZone);
        if (selectedZone !== undefined) {
            map.geoObjects.removeAll();
            showZone(map, selectedZone)
        }
    }, [state.selectedZone, state.zones, map])

    useEffect(() => {
        if (coordinate === undefined) {
            return;
        }

        geocodeAddress(
            `${coordinate[0]} ${coordinate[1]}`,
            (a) => {
                console.log(a.text)
                setAddressText(a.text)
            },
            geocodePointTokenSource
        );
        return () => geocodePointTokenSource.cancel();
    }, [coordinate]);

    useEffect(() => {
        if (suggest === undefined) {
            return;
        }
        geocodeAddress(
            suggest.title.text,
            (a) => {
                map.setCenter(a.coords, 15, {duration: 300});
            },
            geocodeTextTokenSource
        );
        return () => geocodeTextTokenSource.cancel();
    }, [suggest])

    let addressItems = addresses.map((a) => {
        return <a className="Zones_view_mobile__address_list_item" onClick={(e) => {
            setSearchFieldSelected(false)
            setSuggest(a)
        }}>
            <span className="Zones_view_mobile__address_list_item_title">{a.title.text}</span>
            <span className="Zones_view_mobile__address_list_item_subtitle">{a.subtitle.text}</span>
        </a>
    })

    let cars = state.zones?.records.map((record) => {
        return <ZoneLegendCarView
            mobile={true}
            title={record.title}
            icon={record.icon}
            id={record.id}
            selected={state.selectedZone === record.id}
            constants={props.constants}
            onClick={() => setState({...state, selectedZone: record.id})}
        />
    })

    let ability = abilities?.records.find((zone) => zone.id === state.selectedZone);

    return <div className="Zones_view_mobile">
        <div className="Zones_view_mobile_header">
            <span className="Zones_view_mobile__title">Зона поездки</span>
            <Link to="/" className="Zones_view_mobile__arrow">
                <img src={backIcon} style={{width: "11px", height: "21px"}}/>
            </Link>
            <div className="Zones_view_mobile__gradient"/>
            <div
                className={`${searchFieldSelected ? "Zones_view_mobile__address_input_container Zones_view_mobile__address_input_container__selected" : "Zones_view_mobile__address_input_container"} `}>
                <AddressSearch
                    key={addressText}
                    value={addressText}
                    onSelectOnMap={() => setSearchFieldSelected(false)}
                    showSelectOnMapButton={searchFieldSelected}
                    onAddressesUpdate={(a) => setAddresses(a)}
                    onFocus={(e) => setSearchFieldSelected(true)}
                    onBlur={(e) => {
                    }}
                />
            </div>
        </div>
        <div className="Zones_view_mobile__map">
            <Map center={props.city.coordinate} callback={
                // @ts-ignore
                (map: ymaps.Map) => {
                    setMap(map);
                    setCoordinate(map.getCenter())
                    map.events.add('actionend', () => {
                        console.log('action end');
                        setCoordinate(map.getCenter());
                    })
                    map.events.add('actionbegin', () => {
                        console.log('action begin');
                        setAbilities(undefined)
                    })
                }
            }></Map>
        </div>
        <div className="Zones_view_mobile__finger_icon_container">
            <img src={fingerIcon} className="Zones_view_mobile__finger_icon"/>
        </div>
        {searchFieldSelected &&
        <div className="Zones_view_mobile__address_list_container">
            <div className="Zones_view_mobile__address_list">
                <div className="Zones_view_mobile__address_list_internal">
                    {addressItems}
                </div>
            </div>
        </div>
        }
        <div className="Zones_view_mobile__legend_container">
            <div className="Zones_view_mobile__legend_row">
                <div className="Zones_view_mobile__legend">
                    {cars}
                </div>
            </div>
            <div className="Zones_view_mobile__legend_separator"/>
            <span className="Zones_view_mobile__legend_separator_title">В этой точке</span>
            <ZonesAbilitiesView mobile={true} record={ability}/>
        </div>
    </div>
}
